module.exports = __webpack_public_path__ + "static/img/navLogo_new.212458c.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/navLogo_new.png
// module id = pSzw
// module chunks = 1